import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { openAxios } from 'services/axios';
import { ADDRESS } from 'services/consts';

const initialState = {
	countryList: [],
	stateList: {},
	governorateList: {},
	cityList: {},
	districtList: {},
	neighbourhoodList: {}
};

export const getCountryList = createAsyncThunk('globalAddress/getCountryList', async (_, { getState }) => {
	const countryList = getState().globalAddress.countryList;

	if (countryList.length > 0) {
		return countryList;
	}

	const response = await openAxios.post(ADDRESS.GET_COUNTRY_LIST, {});

	return response.data.data;
});

export const getStateByCountry = createAsyncThunk(
	'globalAddress/getStateByCountry',
	async (countryCode, { getState }) => {
		const stateList = getState().globalAddress.stateList;
		const sliceData = stateList[countryCode];

		if (sliceData) {
			return {
				data: sliceData,
				code: countryCode
			};
		}

		const response = await openAxios.post(ADDRESS.GET_STATES_BY_COUNTRY, { name: countryCode });

		return {
			data: response.data.data,
			code: countryCode
		};
	}
);

export const getGovernorates = createAsyncThunk('globalAddress/getGovernorates', async (data, { getState }) => {
	const governorateList = getState().globalAddress.governorateList;
	const sliceData = governorateList[data.countryCode];

	if (sliceData) {
		return sliceData;
	}

	const response = await openAxios.post(ADDRESS.GET_GOVERNORATES, data);
	return response.data.data;
});

export const getCityByCountry = createAsyncThunk(
	'globalAddress/getCityByCountry',
	async (countryCode, { getState }) => {
		const cityList = getState().globalAddress.cityList;
		const sliceData = cityList[countryCode];

		if (sliceData) {
			return {
				data: sliceData,
				code: countryCode
			};
		}

		const response = await openAxios.post(ADDRESS.GET_CITIES_BY_COUNTRY, { name: countryCode });

		return {
			data: response.data.data,
			code: countryCode
		};
	}
);

export const getCityByState = createAsyncThunk('globalAddress/getCityByState', async (stateName, { getState }) => {
	const cityList = getState().globalAddress.cityList;
	const sliceData = cityList[stateName];

	if (sliceData) {
		return {
			data: sliceData,
			code: stateName
		};
	}

	const response = await openAxios.post(ADDRESS.GET_CITIES_BY_STATE, { name: stateName });

	return {
		data: response.data.data,
		code: stateName
	};
});

export const getDistrictByCity = createAsyncThunk('globalAddress/getDistrictByCity', async (cityName, { getState }) => {
	const districtList = getState().globalAddress.districtList;
	const sliceData = districtList[cityName];

	if (sliceData) {
		return {
			data: sliceData,
			code: cityName
		};
	}

	const response = await openAxios.post(ADDRESS.GET_DISTRICTS_BY_CITY, { name: cityName });

	return {
		data: response.data.data,
		code: cityName
	};
});

export const getNeighbourhoodByDistrict = createAsyncThunk(
	'globalAddress/getNeighbourhoodByDistrict',
	async (districtName, { getState }) => {
		const neighbourhoodList = getState().globalAddress.neighbourhoodList;
		const sliceData = neighbourhoodList[districtName];

		if (sliceData) {
			return {
				data: sliceData,
				code: districtName
			};
		}

		const response = await openAxios.post(ADDRESS.GET_NEIGHBORHOODS_BY_DISTRICT, { name: districtName });

		return {
			data: response.data.data,
			code: districtName
		};
	}
);

const globalAddress = createSlice({
	name: 'globalAddress',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getCountryList.fulfilled, (state, { payload }) => ({
			...state,
			countryList: payload
		}));
		builder.addCase(getStateByCountry.fulfilled, (state, { payload }) => ({
			...state,
			stateList: {
				...state.stateList,
				[payload.code]: payload.data
			}
		}));
		builder.addCase(getGovernorates.fulfilled, (state, { payload }) => ({
			...state,
			governorateList: {
				...state.governorateList,
				[payload.code]: payload.data
			}
		}));
		builder.addCase(getCityByCountry.fulfilled, (state, { payload }) => ({
			...state,
			cityList: {
				...state.cityList,
				[payload.code]: payload.data
			}
		}));
		builder.addCase(getCityByState.fulfilled, (state, { payload }) => ({
			...state,
			cityList: {
				...state.cityList,
				[payload.code]: payload.data
			}
		}));
		builder.addCase(getDistrictByCity.fulfilled, (state, { payload }) => ({
			...state,
			districtList: {
				...state.districtList,
				[payload.code]: payload.data
			}
		}));
		builder.addCase(getNeighbourhoodByDistrict.fulfilled, (state, { payload }) => ({
			...state,
			neighbourhoodList: {
				...state.neighbourhoodList,
				[payload.code]: payload.data
			}
		}));
	}
});

export default globalAddress.reducer;
